export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/caricature.c3942ad.svg";